import api, { paginado } from './apiClient'

/** `POST /auth/login` — o token devolvido é o do SSO. */
export const userLogin = async user => {
  const response = await api.post('/auth/login', {
    email: user.email,
    password: user.password,
  })
  return response
}

/** `GET /auth/me` — perfil, roles, permissões e filiais do token atual. */
export const getUser = async () => {
  const response = await api.get('/auth/me')
  return response
}

/** `GET /subcompanies` — filiais do usuário, direto do perfil do SSO. */
export const getSubCompanies = async () => {
  const response = await api.get('/subcompanies')
  return { data: paginado(response) }
}

/**
 * Recuperação de senha é do painel do SSO — o Épico 23 proíbe fluxo paralelo
 * aqui e o contrato da API não expõe rota equivalente.
 */
export const forgotPassword = async () => {
  throw new Error(
    'Recuperação de senha não existe no contrato da API de produção. O fluxo pertence ao SSO.'
  )
}

export const resetPassword = forgotPassword

export const userUpdate = async () => {
  throw new Error('Edição de perfil não existe no contrato da API. O cadastro pertence ao SSO.')
}
